<template>
  <div class="courier-select-component">
    <template v-if="editMode">
      <div class="courier-info courier-info-edit d-flex align-center">
        <v-select
          v-model="curCourierId"
          :items="couriersList"
          item-text="name"
          item-value="id"
          label="Выберите курьера"
          dark
          :rules="rules.required"
          :loading="loading"
          :disabled="loading"
        />
        <button type="button"
                class="action-btn action-btn-save"
                :disabled="loading"
                @click="saveCourierToOrder"
        >
          <font-awesome-icon icon="check" />
        </button>
        <button type="button"
                class="action-btn action-btn-cancel"
                :disabled="loading"
                @click="closeEdit"
        >
          <font-awesome-icon icon="times" />
        </button>
      </div>
    </template>

    <template v-else >
      <div class="courier-info courier-info-static d-flex" @click="showEdit">
        <img v-if="hasCourierImage" class="courier-icon" :src="order.courier.image" alt="courier"/>
        <img v-if="!hasCourierImage" class="courier-icon" src="/img/courier.png" alt="courier"/>
        <span class="name d-flex flex-column">
          <span>Курьер</span>
          <span class="font-weight-medium">{{ getCourierName }}</span>
          <span class="font-weight-medium">{{ getCourierPhone }}</span>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
// import QuickEdit from 'vue-quick-edit'

  import rules from '@/mixins/rules'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import { mapMutations } from 'vuex'

  export default {
    name: 'CourierSelect',
    components: {
    // QuickEdit,
    },
    mixins: [rules, mixinSnackbarMessage],
    props: {
      order: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {
        curCourierId: null,
        editMode: false,
        listIsLoading: false,
        loading: false,
        couriersList: [],
      }
    },
    computed: {
      /* ...mapMutations({
        replaceOrderInList: 'orders/replaceOrderInList',
      }), */
      hasCourierImage () {
        return !!this.order.courier && !!this.order.courier.image
      },
      getCourierName: {
        get: function () {
          if (this.order.basket.basketSource === 'deliveryСlub') {
            return 'Delivery Club'
          }

          if (this.order.basket.basketSource === 'yandex') {
            return 'Яндекс.Еда'
          }

          return this.order.courier ? this.order.courier.name : 'Не назначен'
        },
        set: function (value) {

        },

      },
      getCourierPhone () {
        return this.order.courier ? this.order.courier.phone : ''
      },

    },
    methods: {
      showEdit () {
        if (!this.checkCanChangeCourier()) {
          return
        }
        this.editMode = true

        if (!this.listIsLoading) {
          this.loadCouriers()
        }
      },
      closeEdit () {
        this.editMode = false
        if (this.order.courier) {
          this.curCourierId = this.order.courier.id
        }
      },
      loadCouriers () {
        this.loading = true
        this.$store.dispatch('staff/fetchCouriersInWork', {
          filialId: this.order.filialId,
        })
          .then((res) => {
            this.couriersList = res
            this.listIsLoading = true
          })
          .catch((err) => {
            this.showErrorFromResponse(err)
          })
          .finally(() => {
            this.loading = false
          })
      },
      saveCourierToOrder () {
        if (!this.checkCanChangeCourier() ||
          (this.order.courier && this.curCourierId === this.order.courier.id)) {
          this.editMode = false
          return false
        }
        this.loading = true
        const payload = {
          id: this.order.id,
          courierId: this.curCourierId,
        }
        this.$store.dispatch('orders/changeOrderCourier', payload)
          .then((res) => {
            this.$store.commit('orders/replaceOrderInList', {
              id: this.order.id,
              data: res,
            })
            this.showSuccessMessage('Курьер сохранен')
            this.editMode = false
          })
          .catch((err) => {
            this.showErrorFromResponse(err)
          })
          .finally(() => {
            this.loading = false
          })
      },
      checkCanChangeCourier () {
        if (['preparing', 'assembly', 'readyForIssue', 'inDelivery'].includes(this.order.orderStatus)) {
          return true
        }
        this.showErrorMessage('Изменение курьера невозможно для этого заказа')
        return false
      },

    },
    created () {
      if (this.order.courier) {
        this.curCourierId = this.order.courier.id
      }
    },
  }
</script>

<style scoped lang="less">
.courier-info {
  margin-right: 20px;
  max-width: 300px;

  &-static {
    cursor: pointer;
  }

  &-edit {
    max-width: 300px;
  }

  .courier-icon {
    margin-right: 19px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    flex-shrink: 0;
    object-fit: cover;
  }

  .name {
    color: #ffffff;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .action-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    width: 30px;
    height: 30px;
    font-size: 25px;
    margin-left: 15px;
    cursor: pointer;

    &-save {
      color: #4caf50;
    }
    &-cancel {
      color: red;
    }

    &:hover {
      transform: scale(1.2);
    }
  }
}
</style>
